export interface Texture {
  id: string;
  name: string;
  style: {
    backgroundImage: string;
    backgroundSize: string;
  };
}

export const textures: Texture[] = [
  {
    id: 'dots',
    name: 'Dots',
    style: {
      backgroundImage: 'radial-gradient(circle, #ccc 1px, transparent 1px)',
      backgroundSize: '10px 10px'
    }
  },
  {
    id: 'checkerboard',
    name: 'Checkerboard',
    style: {
      backgroundImage: 'linear-gradient(45deg, #ccc 25%, transparent 25%), linear-gradient(-45deg, #ccc 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ccc 75%), linear-gradient(-45deg, transparent 75%, #ccc 75%)',
      backgroundSize: '10px 10px'
    }
  },
  {
    id: 'lines-horizontal',
    name: 'Horizontal Lines',
    style: {
      backgroundImage: 'linear-gradient(90deg, #ccc 1px, transparent 1px)',
      backgroundSize: '10px 10px'
    }
  },
  {
    id: 'lines-vertical',
    name: 'Vertical Lines',
    style: {
      backgroundImage: 'linear-gradient(0deg, #ccc 1px, transparent 1px)',
      backgroundSize: '10px 10px'
    }
  },
  {
    id: 'lines',
    name: 'Diagonal Lines',
    style: {
      backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 2px, #ccc 2px, #ccc 4px)',
      backgroundSize: '10px 10px'
    }
  },
  {
    id: 'grid',
    name: 'Grid',
    style: {
      backgroundImage: 'linear-gradient(#ccc 1px, transparent 1px), linear-gradient(90deg, #ccc 1px, transparent 1px)',
      backgroundSize: '10px 10px'
    }
  },
  {
    id: 'waves',
    name: 'Waves',
    style: {
      backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 10px, #ccc 10px, #ccc 12px)',
      backgroundSize: '10px 10px'
    }
  }
];

// 获取纹理模式的函数
export const getTexturePattern = (texture: string): string => {
  const textureItem = textures.find(t => t.id === texture);
  return textureItem ? textureItem.style.backgroundImage : 'none';
};

// 获取纹理样式的函数
export const getTextureStyle = (texture: string) => {
  const textureItem = textures.find(t => t.id === texture);
  return textureItem ? textureItem.style : {};
}; 